import { useCmsData } from '~/App/shared/hooks/useCmsData';
import { FaqPageDocument, FaqPageQuery } from '~/config/generated/graphql';
import { CmsDataHandlerValue } from '../../actions/cmsDataActions';

export const useFAQPageCmsData = () => {
  const cmsData = useCmsData<FaqPageQuery, CmsDataHandlerValue<'faqPage'>>({
    storeKey: 'faqPage',
    query: FaqPageDocument
  });

  return cmsData;
};
